// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"delta-pro-ultra_productcontent__L1mY7"};